import axios from 'axios';
import type { PublicPlatformBillingCatalog } from '@/types/platformBilling';

// Public landing prices do not need the authenticated client's session interceptors.
const publicBillingApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL?.replace(/[^a-zA-Z0-9:/._-]/g, '') || '',
});

export const getPublicPlatformBillingCatalog = async (): Promise<PublicPlatformBillingCatalog> => {
  const response = await publicBillingApi.get<{ data: PublicPlatformBillingCatalog }>(
    '/platform-billing/public-plans',
  );
  return response.data.data;
};
